// extracted by mini-css-extract-plugin
module.exports = {"refeicao":"Refeicao_refeicao__3SPYH","editando":"Refeicao_editando__1QKf0","refeicaoMenuOpcoes":"Refeicao_refeicaoMenuOpcoes__1JgjZ","focada":"Refeicao_focada__24Iml"};